import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { submitDealerApplication } from '../services/public';
import './DealerApplicationPage.css';
import BrandLogo from '../components/BrandLogo';

const DealerApplicationPage: React.FC = () => {
  const [companyName, setCompanyName] = useState('');
  const [contactName, setContactName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [website, setWebsite] = useState('');
  const [address, setAddress] = useState('');
  const [country, setCountry] = useState('Deutschland');
  const [message, setMessage] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!companyName || !contactName || !email || !address || !country) {
      setError('Bitte fülle alle Pflichtfelder aus.');
      return;
    }

    setLoading(true);
    try {
      await submitDealerApplication({
        companyName,
        contactName,
        email,
        phone: phone || undefined,
        website: website || undefined,
        address,
        country,
        message: message || undefined,
      });
      setSuccess('Vielen Dank! Deine Bewerbung wurde erfolgreich übermittelt.');
      setCompanyName('');
      setContactName('');
      setEmail('');
      setPhone('');
      setWebsite('');
      setAddress('');
      setCountry('Deutschland');
      setMessage('');

      // Nach kurzer Zeit zurück zur Landing Page
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } catch (err: any) {
      const message = err.response?.data?.error || 'Die Bewerbung konnte nicht gesendet werden.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dealer-application-page">
      <header className="dealer-application-header">
        <div className="container">
          <div className="dealer-application-header-inner">
            <Link to="/" className="dealer-application-logo" aria-label="ELFHALBE — zur Startseite">
              <BrandLogo height={18} withIcon />
            </Link>
            <nav>
              <Link to="/" className="header-link">
                Startseite
              </Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="dealer-application-main">
        <div className="container">
          <div className="dealer-application-card">
            <h1>Interesse geweckt?</h1>
            <p>
              Fülle bitte das Formular aus, um offizieller Händler für unsere Skibrillen mit
              optischen Einsätzen zu werden.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="companyName">Firma *</label>
                <input
                  id="companyName"
                  type="text"
                  value={companyName}
                  onChange={e => setCompanyName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="contactName">Ansprechpartner *</label>
                <input
                  id="contactName"
                  type="text"
                  value={contactName}
                  onChange={e => setContactName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">E-Mail *</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Telefon</label>
                <input
                  id="phone"
                  type="tel"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="website">Website</label>
                <input
                  id="website"
                  type="url"
                  value={website}
                  onChange={e => setWebsite(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="address">Adresse *</label>
                <input
                  id="address"
                  type="text"
                  value={address}
                  onChange={e => setAddress(e.target.value)}
                  placeholder="Straße und Hausnummer"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="country">Land *</label>
                <select id="country" value={country} onChange={e => setCountry(e.target.value)}>
                  <option>Deutschland</option>
                  <option>Österreich</option>
                  <option>Schweiz</option>
                  <option>Italien</option>
                  <option>Frankreich</option>
                  <option>Anderes Land</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="message">Nachricht</label>
                <textarea
                  id="message"
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  placeholder="Optional: Zusätzliche Informationen zu deiner Bewerbung"
                />
              </div>

              {error && <div className="error">{error}</div>}
              {success && <div className="success">{success}</div>}

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Wird gesendet...' : 'Bewerbung abschicken'}
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DealerApplicationPage;
